module.exports = __webpack_public_path__ + "img/himg3.508ff5fa.jpg";